import { render } from "./HomeCarousel.vue?vue&type=template&id=04467f5d&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"

import "./HomeCarousel.vue?vue&type=style&index=0&id=04467f5d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04467f5d"]])

export default __exports__